import { Dispatch, SetStateAction } from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { ViewByClaimType, ViewByDocumentType } from "@/types";

export type ViewByOptions = ViewByClaimType | ViewByDocumentType;

type ViewBySelectProps = {
  viewBy: {
    title: string;
    selection: ViewByOptions;
    onChange: Dispatch<SetStateAction<string>>;
    options: {
      optionTitle: string;
      optionType: ViewByOptions;
    }[];
  };
  disabled?: boolean;
};

const ViewBySelect = ({ viewBy, disabled }: ViewBySelectProps) => {
  const { title, selection, onChange, options } = viewBy;

  return (
    <FormControl fullWidth size="small">
      <InputLabel>{title}</InputLabel>
      <Select value={selection} label={title} onChange={(e) => onChange(e.target.value)} disabled={disabled}>
        {options.map(({ optionTitle, optionType }) => (
          <MenuItem value={optionType}>{optionTitle}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default ViewBySelect;
